import { getHostName } from "../utils";

export async function getCalendarInformation(filter) {
  const jsonString = encodeURIComponent(JSON.stringify(filter));
  const data = await fetch(`${getHostName()}/api/calendarstats/?filter=${jsonString}`);
  return await data.json();
}
